// ----------------------------------------------------------------------
// <copyright file="Izenda.CalculatedFieldConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';

const FUNCTION_NAME = {
  NONE: '',
  EXPRESSION: '[Expression]',
  DEFAULT: 'Default',
  AVERAGE: 'Average',
  COUNT: 'Count',
  COUNT_DISTINCT: 'Count Distinct',
  MAXIMUM: 'Maximum',
  MINIMUM: 'Minimum',
  SUM: 'Sum',
  SUM_DISTINCT: 'Sum Distinct'
};

export default {
  get DATA_TYPES() {
    return [
      // { lable, value, functions for data type values, can change to data types }
      {
        label: localizer.getText('CALCULATED_FIELD_CONSTANTS_LABEL_DATA_TYPES_NUMERIC'),
        value: 'Numeric',
        functions: [
          FUNCTION_NAME.NONE,
          FUNCTION_NAME.EXPRESSION,
          FUNCTION_NAME.DEFAULT,
          FUNCTION_NAME.AVERAGE,
          FUNCTION_NAME.COUNT,
          FUNCTION_NAME.COUNT_DISTINCT,
          FUNCTION_NAME.MAXIMUM,
          FUNCTION_NAME.MINIMUM,
          FUNCTION_NAME.SUM,
          FUNCTION_NAME.SUM_DISTINCT
        ],
        toDataTypes: ['Text', 'Boolean', 'Money', 'Lob']
      },
      {
        label: localizer.getText('CALCULATED_FIELD_CONSTANTS_LABEL_DATA_TYPES_DATETIME'),
        value: 'Datetime',
        functions: [
          FUNCTION_NAME.NONE,
          FUNCTION_NAME.EXPRESSION,
          FUNCTION_NAME.COUNT,
          FUNCTION_NAME.COUNT_DISTINCT,
          FUNCTION_NAME.MAXIMUM,
          FUNCTION_NAME.MINIMUM
        ],
        toDataTypes: ['Numeric', 'Text', 'Boolean', 'Money', 'Lob']
      },
      {
        label: localizer.getText('CALCULATED_FIELD_CONSTANTS_LABEL_DATA_TYPES_TEXT'),
        value: 'Text',
        functions: [
          FUNCTION_NAME.NONE,
          FUNCTION_NAME.EXPRESSION,
          FUNCTION_NAME.COUNT,
          FUNCTION_NAME.COUNT_DISTINCT,
          FUNCTION_NAME.MAXIMUM,
          FUNCTION_NAME.MINIMUM
        ],
        toDataTypes: ['Numeric', 'Datetime', 'Image', 'Boolean', 'Money', 'Lob']
      },
      {
        label: localizer.getText('CALCULATED_FIELD_CONSTANTS_LABEL_DATA_TYPES_IMAGE'),
        value: 'Image',
        functions: [],
        toDataTypes: ['Lob']
      },
      {
        label: localizer.getText('CALCULATED_FIELD_CONSTANTS_LABEL_DATA_TYPES_BOOLEAN'),
        value: 'Boolean',
        functions: [
          FUNCTION_NAME.NONE,
          FUNCTION_NAME.EXPRESSION,
          FUNCTION_NAME.AVERAGE,
          FUNCTION_NAME.COUNT,
          FUNCTION_NAME.COUNT_DISTINCT,
          FUNCTION_NAME.SUM,
          FUNCTION_NAME.SUM_DISTINCT
        ],
        toDataTypes: ['Numeric', 'Text', 'Money', 'Lob']
      },
      {
        label: localizer.getText('CALCULATED_FIELD_CONSTANTS_LABEL_DATA_TYPES_MONEY'),
        value: 'Money',
        functions: [
          FUNCTION_NAME.NONE,
          FUNCTION_NAME.EXPRESSION,
          FUNCTION_NAME.DEFAULT,
          FUNCTION_NAME.AVERAGE,
          FUNCTION_NAME.COUNT,
          FUNCTION_NAME.COUNT_DISTINCT,
          FUNCTION_NAME.MAXIMUM,
          FUNCTION_NAME.MINIMUM,
          FUNCTION_NAME.SUM,
          FUNCTION_NAME.SUM_DISTINCT
        ],
        toDataTypes: ['Numeric', 'Datetime', 'Text', 'Boolean', 'Lob']
      },
      {
        label: localizer.getText('CALCULATED_FIELD_CONSTANTS_LABEL_DATA_TYPES_LOB'),
        value: 'Lob',
        functions: [],
        toDataTypes: ['Datetime', 'Image', 'Boolean', 'Money']
      }
    ];
  },
  get FUNCTIONS() {
    return [
      { label: localizer.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_NAME_NONE'), value: FUNCTION_NAME.NONE },
      {
        label: localizer.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_NAME_EXPRESSION'),
        value: FUNCTION_NAME.EXPRESSION
      },
      { label: localizer.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_NAME_DEFAULT'), value: FUNCTION_NAME.DEFAULT },
      { label: localizer.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_NAME_AVERAGE'), value: FUNCTION_NAME.AVERAGE },
      { label: localizer.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_NAME_COUNT'), value: FUNCTION_NAME.COUNT },
      {
        label: localizer.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_NAME_COUNT_DISTINCT'),
        value: FUNCTION_NAME.COUNT_DISTINCT
      },
      { label: localizer.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_NAME_MAXIMUM'), value: FUNCTION_NAME.MAXIMUM },
      { label: localizer.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_NAME_MINIMUM'), value: FUNCTION_NAME.MINIMUM },
      { label: localizer.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_NAME_SUM'), value: FUNCTION_NAME.SUM },
      {
        label: localizer.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_NAME_SUM_DISTINCT'),
        value: FUNCTION_NAME.SUM_DISTINCT
      }
    ];
  },
  FUNCTION_NAME: FUNCTION_NAME,
  TYPES: {
    ADD: {
      get title() {
        return localizer.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_TYPE_ADD_TITLE');
      },
      get name() {
        return localizer.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_TYPE_ADD_NAME');
      },
      enableValidateDataType: false
    },
    EDIT: {
      get title() {
        return localizer.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_TYPE_EDIT_TITLE');
      },
      get name() {
        return localizer.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_TYPE_EDIT_NAME');
      },
      enableValidateDataType: false
    },
    GRAND_TOTAL: {
      get title() {
        return localizer.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_TYPE_GRAND_TOTAL_TITLE');
      },
      get name() {
        return localizer.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_TYPE_GRAND_TOTAL_NAME');
      },
      get functionLabel() {
        return localizer.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_TYPE_GRAND_TOTAL_FUNCTION_LABEL');
      },
      enableValidateDataType: true,
      grandTotalProperties: 'grandTotal'
    },
    SUB_TOTAL: {
      get title() {
        return localizer.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_TYPE_SUB_TOTAL_TITLE');
      },
      get name() {
        return localizer.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_TYPE_SUB_TOTAL_NAME');
      },
      get functionLabel() {
        return localizer.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_TYPE_SUB_TOTAL_FUNCTION_LABEL');
      },
      enableValidateDataType: true,
      subTotalProperties: 'subTotal'
    }
  },
  EXPRESSION_EXAMPLE: 'COUNT([FieldName1]) + SUM([FieldName2])',
  COLUMN_NAME_CONSTRAINT: function(name) {
    return {
      presence: {
        presence: true,
        message: name + localizer.getText('COMMON_REQUIRE_CONSTRAINT')
      }
    };
  },
  EXPRESSION_CONSTRAINT: function(disabledExpression) {
    if (!disabledExpression)
      return {
        presence: {
          presence: true,
          message: localizer.getText('CALCULATED_FIELD_CONSTANTS_MESSAGE_EXPRESSION_CONSTRAINT')
        }
      };
  },

  get EXPRESSION_SELECTION_TABS() {
    return {
      fieldName: {
        title: localizer.getText('CALCULATED_FIELD_CONSTANTS_TITLE_EXPRESSION_SELECTION_TABS_FIELD_NAME'),
        tabkey: 'fieldName'
      },
      functionOperator: {
        title: localizer.getText('CALCULATED_FIELD_CONSTANTS_TITLE_EXPRESSION_SELECTION_TABS_FUNCTION_OPERATOR'),
        tabkey: 'functionOperator'
      }
    };
  },

  get FIELD_NAME() {
    return {
      instruction: localizer.getText('CALCULATED_FIELD_CONSTANTS_FIELD_NAME_INSTRUCTION'),
      dataSourceLabel: localizer.getText('COMMON_LABEL_DATA_SOURCE'),
      enableDataSource: true
    };
  },

  get FUNCTION_OPERATOR() {
    return {
      instruction: localizer.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_OPERATOR_INSTRUCTION')
    };
  },

  get TABLE_DEFINITION() {
    return {
      FieldName: {
        fieldName: {
          columnKey: 'name',
          title: localizer.getText('CALCULATED_FIELD_CONSTANTS_TABLE_DEFINITION_FIELD_NAME_FIELD_NAME'),
          sortable: true,
          width: 150
        },
        dataType: {
          columnKey: 'dataType',
          title: localizer.getText('COMMON_LABEL_DATA_TYPE'),
          sortable: true,
          width: 150
        },
        description: {
          columnKey: 'description',
          title: localizer.getText('CALCULATED_FIELD_CONSTANTS_TABLE_DEFINITION_FIELD_NAME_DESCRIPTION'),
          sortable: true,
          width: 160
        }
      },
      FunctionOperator: {
        name: {
          columnKey: 'name',
          title: localizer.getText('CALCULATED_FIELD_CONSTANTS_TABLE_DEFINITION_FUNCTION_OPERATOR_NAME'),
          sortable: true,
          width: 230
        },
        syntax: {
          columnKey: 'syntax',
          title: localizer.getText('CALCULATED_FIELD_CONSTANTS_TABLE_DEFINITION_FUNCTION_OPERATOR_SYNTAX'),
          sortable: true,
          width: 230
        }
      }
    };
  },
  get MESSAGES() {
    return {
      M01: localizer.getText('CALCULATED_FIELD_CONSTANTS_MESSAGE_DELETE_CALCULATED_FIELD'),
      M02: localizer.getText('CALCULATED_FIELD_CONSTANTS_MESSAGE_DELETE_CALCULATED_FIELD_REPORT_PART'),
      M04: localizer.getText('CALCULATED_FIELD_CONSTANTS_MESSAGE_RESULT_CANNOT_FORMATED'),
      DUPLICATE_NAME: localizer.getText('CALCULATED_FIELD_CONSTANTS_MESSAGE_DUPLICATE_NAME'),
      PM02: localizer.getText('PREDICTED_FIELD_CONSTANTS_MESSAGE_DELETE_PREDICTED_FIELD_REPORT_PART'),
      PM01:localizer.getText('PREDICTED_FIELD_DELETE_COLUMN')
    };
  },
  VALIDATION_FIELD_NAME: 'columnName',
  VALIDATION_SUB_TOTAL_FIELD_NAME: 'name',
  EMPTY_GUID: '00000000-0000-0000-0000-000000000000',
  VALIDATION_DATA_TYPE: 'izendaDataType'
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.CalculatedFieldConstants.js